module.exports = __webpack_public_path__ + "img/team.abcb5b68.webp";